/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import {
  AI_CONTENT_TOOLS,
  AI_VIEW_CONTENT_TOOL,
  CONFIGURATION_DASHBOARD,
  DAM_INTEGRATIONS,
  DAM_INTEGRATION_DETAILS,
  EVENT_SERVICE,
  EVENT_SUBSCRIPTIONS_BUILDER_CREATE,
  EVENT_SUBSCRIPTIONS_BUILDER_EDIT,
  JOB_EXECUTION,
  JOB_RUNNER,
  SERVICE_SETTINGS,
  STATIC_SITES,
  STATIC_SITES_MANAGE_ROUTING,
} from './Screens.constants';

/**
 * All navigation items that make up Configuration screens.
 */
export const DXP_MENU_CONFIGURATION_SCREENS: Array<NavigationItem> = [
  CONFIGURATION_DASHBOARD,
  AI_CONTENT_TOOLS,
  AI_VIEW_CONTENT_TOOL,
  DAM_INTEGRATIONS,
  DAM_INTEGRATION_DETAILS,
  EVENT_SERVICE,
  EVENT_SUBSCRIPTIONS_BUILDER_CREATE,
  EVENT_SUBSCRIPTIONS_BUILDER_EDIT,
  JOB_RUNNER,
  JOB_EXECUTION,
  SERVICE_SETTINGS,
  STATIC_SITES,
  STATIC_SITES_MANAGE_ROUTING,
];
